export default "__VITE_ASSET__863660b9__"